<div class="uploadChallan">
    <h1>Upload Material</h1>
    <br/>
    <h5>Upload Files</h5>
    <span style="color:#53565A">XLS, JPG, JPEG, PNG, PDF ,DOC. Max Size of 10 MB</span>
    <div type="file" class="inputBox" (change)="base($event)">
        Choose File
        <input style="opacity: 0.0; position: absolute; top: 130px; left: 10px; bottom: 0; right: 0; width: 20%; height:20%;" (change)="base($event)" type="file" id="file">
    </div>
    <br/>
    <!-- For PDF: simple link preview instead of embedded viewer -->
    <div *ngIf="this.type === 'application/pdf'" [ngClass]="{'viewChallanBox':this.pdfSrc.length > 0}">
        <img *ngIf="this.load==true" src="../../../../assets/images/buffering.gif" [ngClass]="{'viewLoader':this.load==true}" height="100px" width="100px"/>
        <a *ngIf="this.load==false && pdfSrc" [href]="pdfSrc" target="_blank">Open PDF in new tab</a>
    </div>

   <!-- For doc and docx -->
 <div *ngIf="this.type === 'application/msword' || this.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'" class="viewChallanBox fixed-container">
    <img *ngIf="this.load==true" src="../../../../assets/images/buffering.gif" class="viewLoader" height="100px" width="100px"/>   
    <div [innerHTML]="docSrc"></div>
</div>


     <!-- For excel -->
     <div *ngIf="this.type === 'application/vnd.ms-excel' || this.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
     this.type === 'application/vnd.ms-excel.sheet.macroEnabled.12'" [ngClass]="viewChallanBox">
     <img *ngIf="this.load==true" src="../../../../assets/images/buffering.gif" [ngClass]="{'viewLoader':this.load==true}" height="100px" width="100px"/>
     <div *ngIf="this.load==false" class="fixed-table-container">
         <table class="fixed-table">
             <tr *ngFor="let row of excelData">
                 <td *ngFor="let cell of row">{{ cell }}</td>
             </tr>
         </table>
     </div>
 </div>

    <!-- For Image -->
    <div *ngIf="this.type !== 'application/pdf'">
        <img *ngIf="this.load==true" src="../../../../assets/images/buffering.gif" [ngClass]="{'viewLoader':this.load==true}" height="100px" width="100px"/>
        <img *ngIf="this.load==false" [src]="url" [ngClass]="{'viewImageBox':this.url.length > 0}"/><br/>
    </div>

    <div class="d-flex justify-content-end" style="margin-top:15px;margin-right: -10px">
        <button (click)="Cancel()" class="button" type="button" style="background-color: #53565A;color:#fff">
           Close
        </button>
        <button (click)="Submit()" class="button" type="button blue" [disabled]="isSubmitDisabled()" style="background: #007CB0;color:#fff">Submit</button>
    </div>
</div>